module.exports = __webpack_public_path__ + "img/banner1-home.5278fb2a.jpg";